const EmptyCard = () => {
  return (
    <div className="bookito-card__loader mr-5 animate-pulse min-w-min min-w-lg  bg-white border border-gray-200 rounded-3xl shadow dark:bg-gray-800 dark:border-gray-700 text-left">
      <div className="p-5 w-[80vw] md:w-80 lg:w-96">
        <h5 className="mb-3 rounded-md max-w-fit px-2 bg-white text-md font-black tracking-tight text-gray-900 dark:text-black">
          <div className="h-2 bg-slate-200 rounded"></div>
        </h5>

        <h5 className="mb-10 text-2xl font-bold tracking-tight  text-gray-50 dark:text-white">
          <div className="grid grid-cols-3 gap-4 mt-1">
            <div className="h-4 bg-slate-200 rounded col-span-2"></div>
          </div>
          <div className="grid grid-cols-3 gap-4 mt-2">
            <div className="h-4 bg-slate-200 rounded col-span-1"></div>
          </div>
        </h5>

        <div className="mb-2 dark:text-white text-gray-50 mt-6">
          {new Array(4).fill(undefined).map((_, key) => (
            <div className="grid grid-cols-3 gap-4 mt-2" key={key}>
              <div className="h-2 bg-slate-200 rounded col-span-3"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmptyCard;
